import Constants from '../../utils/constants';
import { TEMPERATURE_RANGE } from '../../utils/formulas';

export default class DefaultPart {
  get selectedTemperatureRange() {
    const paramKey = Constants.CDP.PARAMETERS.TEMPERATURE_RANGE;
    if (!(this.selected && paramKey in this.selected)) return { min: null, max: null };

    const tempRange = this.selected[paramKey];

    if (tempRange.value && tempRange.value.length) {
      return TEMPERATURE_RANGE(tempRange.value[0]);
    } else {
      return {
        min: null,
        max: null,
      };
    }
  }
}
